import {
  DecisionPageLayout,
  DecisionSection,
} from "@/components/DecisionPageLayout";
import {
  SpravatoSafetyBlock,
  SpravatoInternalLinks,
} from "@/components/SpravatoSafetyBlock";
const SpravatoFitsYourSchedule = () => (
  <DecisionPageLayout
    seo={{
      title:
        "When You Can't Take a Week Off — SPRAVATO® | Neuro Wellness TMS Centers of America",
      description:
        "The treatments you've read about don't fit your life. Learn about SPRAVATO® — a local, ongoing treatment for treatment-resistant depression that works around your schedule.",
      canonical: "/spravato-fits-your-schedule",
      keywords:
        "SPRAVATO schedule, treatment-resistant depression working, local depression treatment, Coral Springs FL",
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "MedicalWebPage",
        name: "When You Can't Take a Week Off — SPRAVATO®",
        about:
          "SPRAVATO® as a local, ongoing treatment option for treatment-resistant depression when intensive programs don't fit.",
        provider: {
          "@id": "https://neurowellnesstms.com/#organization",
        },
      },
    }}
    badge="SPRAVATO® · Recognition"
    title="The treatments you've read about don't fit your life"
    subtitle="You've done the math against a job that doesn't flex, or kids who need picking up, or an hourly wage where missing days means missing rent."
    ctaHeading="Ask about the logistics first"
    ctaText="Genuinely — call and ask about scheduling before anything else. If the shape doesn't work, better to know now. Schedule a free phone consultation or call (954) 827-9793."
  >
    <DecisionSection heading="The treatments you've read about don't fit your life">
      <p>
        You've done some research. You've seen the intensive programs — a week
        away, travel, hotels. You've seen standard TMS, which means daily
        appointments for about nine weeks.
      </p>
      <p>
        And you've done the math against a job that doesn't flex, or kids who
        need picking up, or an hourly wage where missing days means missing
        rent.
      </p>
      <p>
        So you closed the tab. Not because you didn't want help. Because the
        help wasn't shaped like your life.
      </p>
    </DecisionSection>

    <DecisionSection heading="The structure of SPRAVATO® treatment">
      <p>
        It's local and ongoing rather than a block of time away. You keep living
        where you live.
      </p>
      <p>
        The schedule tapers. Twice weekly to start, then weekly, then spacing
        further out as things improve.
      </p>
      <p>
        Each visit is about three hours — a few minutes of dosing, then the
        required two-hour observation.
      </p>
      <p>
        Every visit needs a ride. This is the real logistical demand, and it's
        worth being honest that eight rides in the first month takes planning.
      </p>
      <p>
        Medical leave may apply. SPRAVATO® is a medical treatment, and some
        people use intermittent leave for the induction phase. We can provide
        documentation for an employer.
      </p>
    </DecisionSection>

    <DecisionSection heading="Being clear about the tradeoff">
      <p>
        This isn't a lighter commitment than the alternatives — it's a
        differently shaped one. More visits over more weeks, but none of them
        require you to leave home or step out of your life entirely.
      </p>
      <p>For a lot of people that's the version that's actually possible.</p>
      <p>
        SPRAVATO® is FDA-approved for treatment-resistant depression, carries a
        boxed warning, and is only given at certified centers. Whether it's
        appropriate for you is a clinical determination.
      </p>
    </DecisionSection>

    <SpravatoInternalLinks />
    <SpravatoSafetyBlock />
  </DecisionPageLayout>
);
export default SpravatoFitsYourSchedule;
